// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var DOM$SmartcutsMacros = require("../DOM.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var DOM__Attributes$SmartcutsMacros = require("../DOM__Attributes.bs.js");
var RadioOrSelectOption$SmartcutsMacros = require("./shared/RadioOrSelectOption.bs.js");
var DomElementIdentifierGenerator$SmartcutsMacros = require("../DomElementIdentifierGenerator.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("../DomElementIdentifierPaired__WithSelector.bs.js");

function radioOptions_encode(v) {
  return Js_dict.fromArray([
              [
                "options",
                Decco.arrayToJson(RadioOrSelectOption$SmartcutsMacros.t_encode, v.options)
              ],
              [
                "indexSelected",
                Decco.intToJson(v.indexSelected)
              ]
            ]);
}

function radioOptions_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var options = Decco.arrayFromJson(RadioOrSelectOption$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
  if (options.TAG === /* Ok */0) {
    var indexSelected = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "indexSelected"), null));
    if (indexSelected.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                options: options._0,
                indexSelected: indexSelected._0
              }
            };
    }
    var e = indexSelected._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".indexSelected" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = options._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".options" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function radioInput_encode(v) {
  return Js_dict.fromArray([
              [
                "options",
                Decco.arrayToJson(RadioOrSelectOption$SmartcutsMacros.t_encode, v.options)
              ],
              [
                "selected",
                RadioOrSelectOption$SmartcutsMacros.t_encode(v.selected)
              ]
            ]);
}

function radioInput_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var options = Decco.arrayFromJson(RadioOrSelectOption$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
  if (options.TAG === /* Ok */0) {
    var selected = RadioOrSelectOption$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selected"), null));
    if (selected.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                options: options._0,
                selected: selected._0
              }
            };
    }
    var e = selected._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".selected" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = options._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".options" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function labeledRadioInputValue_encode(v) {
  return Js_dict.fromArray([
              [
                "label",
                Decco.optionToJson(Decco.stringToJson, v.label)
              ],
              [
                "value",
                radioInput_encode(v.value)
              ]
            ]);
}

function labeledRadioInputValue_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
  if (label.TAG === /* Ok */0) {
    var value = radioInput_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                label: label._0,
                value: value._0
              }
            };
    }
    var e = value._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".value" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function labeledRadioOptions_encode(v) {
  return Js_dict.fromArray([
              [
                "label",
                Decco.optionToJson(Decco.stringToJson, v.label)
              ],
              [
                "value",
                radioOptions_encode(v.value)
              ]
            ]);
}

function labeledRadioOptions_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
  if (label.TAG === /* Ok */0) {
    var value = radioOptions_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                label: label._0,
                value: value._0
              }
            };
    }
    var e = value._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".value" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "domElementIdentifierWithSelector",
                DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
              ],
              [
                "radioInputParam",
                labeledRadioOptions_encode(v.radioInputParam)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
  if (domElementIdentifierWithSelector.TAG === /* Ok */0) {
    var radioInputParam = labeledRadioOptions_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "radioInputParam"), null));
    if (radioInputParam.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                radioInputParam: radioInputParam._0
              }
            };
    }
    var e = radioInputParam._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".radioInputParam" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = domElementIdentifierWithSelector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domElementIdentifierWithSelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify(param) {
  return "{domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + ", radioInputParam}");
}

function fromInputEvent(domElementIdentifierGenerator, inputEvent) {
  var target = inputEvent.target;
  var tagName = target.tagName.toLowerCase();
  var match = DOM__Attributes$SmartcutsMacros.ofDomElement(target);
  var type_ = match.type_;
  if (tagName !== "input") {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected event to target '<input type='radio'>'");
  }
  if (type_ === undefined) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected event to target '<input type='radio'>'");
  }
  if (type_ !== "radio") {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected event to target '<input type='radio'>'");
  }
  var selectorString = Selector$SmartcutsMacros.stringify((function (v) {
          switch (v.TAG | 0) {
            case /* Id */1 :
            case /* AtIndex */4 :
                return false;
            default:
              return true;
          }
        }), false, Selector$SmartcutsMacros.forDomEventTarget(target));
  var value = Belt_Array.reduceWithIndex(Array.prototype.slice.call(document.querySelectorAll(selectorString)), {
        options: [],
        indexSelected: -1
      }, (function (state, node, index) {
          var arg = Webapi__Dom__Element.ofNode(node);
          var optionElement = (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg);
              })("expected element nodes as result of document.querySelectorAll()");
          var options = $$Array.append(state.options, [RadioOrSelectOption$SmartcutsMacros.fromDomElement(optionElement)]);
          if (Caml_obj.caml_equal(optionElement, target)) {
            return {
                    options: options,
                    indexSelected: index
                  };
          } else {
            return {
                    options: options,
                    indexSelected: state.indexSelected
                  };
          }
        }));
  var selector = Selector$SmartcutsMacros.forDomEventTarget(target);
  var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(target, domElementIdentifierGenerator);
  var label = OptionUtils$SmartcutsMacros.map(DOM$SmartcutsMacros.$$EventTarget.deduceNameOfInput(target), (function (name) {
          return name.replace(/_+/g, " ");
        }));
  return {
          domElementIdentifierWithSelector: {
            domElementIdentifier: domElementIdentifier,
            selector: selector
          },
          radioInputParam: {
            label: label,
            value: value
          }
        };
}

var Recording = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  fromInputEvent: fromInputEvent
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "radioInputParam",
                labeledRadioOptions_encode(v.radioInputParam)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var radioInputParam = labeledRadioOptions_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "radioInputParam"), null));
    if (radioInputParam.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                selector: selector._0,
                radioInputParam: radioInputParam._0
              }
            };
    }
    var e = radioInputParam._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".radioInputParam" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromRecordingCommandValue(param) {
  return {
          selector: param.domElementIdentifierWithSelector.selector,
          radioInputParam: param.radioInputParam
        };
}

function updateSelector(f, param) {
  return {
          selector: Curry._1(f, param.selector),
          radioInputParam: param.radioInputParam
        };
}

function getInputIdentifier(param) {
  return Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}

function stringify$1(param) {
  return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + ", radioInputParam}");
}

var Authoring = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromRecordingCommandValue: fromRecordingCommandValue,
  updateSelector: updateSelector,
  getInputIdentifier: getInputIdentifier,
  stringify: stringify$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "radioInputParam",
                labeledRadioInputValue_encode(v.radioInputParam)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var radioInputParam = labeledRadioInputValue_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "radioInputParam"), null));
    if (radioInputParam.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                selector: selector._0,
                radioInputParam: radioInputParam._0
              }
            };
    }
    var e = radioInputParam._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".radioInputParam" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromAuthoringCommandValue(param) {
  var match = param.radioInputParam;
  var match$1 = match.value;
  var options = match$1.options;
  var selected = Caml_array.get(options, match$1.indexSelected);
  return {
          selector: param.selector,
          radioInputParam: {
            label: match.label,
            value: {
              options: options,
              selected: selected
            }
          }
        };
}

function selectorGet(param) {
  return [param.selector];
}

function stringify$2(param) {
  return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + ", radioInputParam}");
}

var Playback = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromAuthoringCommandValue: fromAuthoringCommandValue,
  selectorGet: selectorGet,
  stringify: stringify$2
};

var CommandValue = {
  radioOptions_encode: radioOptions_encode,
  radioOptions_decode: radioOptions_decode,
  radioInput_encode: radioInput_encode,
  radioInput_decode: radioInput_decode,
  labeledRadioInputValue_encode: labeledRadioInputValue_encode,
  labeledRadioInputValue_decode: labeledRadioInputValue_decode,
  labeledRadioOptions_encode: labeledRadioOptions_encode,
  labeledRadioOptions_decode: labeledRadioOptions_decode,
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

function isDynamic(param) {
  return param.dynamic;
}

function fromAuthoringCommandValue$1(param) {
  var originalLabeledValue = param.radioInputParam;
  return {
          targetLocator: param.selector,
          originalLabeledValue: originalLabeledValue,
          playbackFormLabel: OptionUtils$SmartcutsMacros.withDefault("[Add a label]", originalLabeledValue.label),
          dynamic: false
        };
}

function updateConfigWithAuthoringCommandValue(param, config) {
  return {
          targetLocator: config.targetLocator,
          originalLabeledValue: param.radioInputParam,
          playbackFormLabel: config.playbackFormLabel,
          dynamic: config.dynamic
        };
}

var AuthoringConfig = {
  isDynamic: isDynamic,
  fromAuthoringCommandValue: fromAuthoringCommandValue$1,
  updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "targetLocator",
                Selector$SmartcutsMacros.selector_encode(v.targetLocator)
              ],
              [
                "originalLabeledValue",
                labeledRadioOptions_encode(v.originalLabeledValue)
              ],
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
  if (targetLocator.TAG === /* Ok */0) {
    var originalLabeledValue = labeledRadioOptions_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalLabeledValue"), null));
    if (originalLabeledValue.TAG === /* Ok */0) {
      var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
      if (playbackFormLabel.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  targetLocator: targetLocator._0,
                  originalLabeledValue: originalLabeledValue._0,
                  playbackFormLabel: playbackFormLabel._0
                }
              };
      }
      var e = playbackFormLabel._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".playbackFormLabel" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = originalLabeledValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".originalLabeledValue" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = targetLocator._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".targetLocator" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromAuthoringConfig(param) {
  return {
          targetLocator: param.targetLocator,
          originalLabeledValue: param.originalLabeledValue,
          playbackFormLabel: param.playbackFormLabel
        };
}

var ParamDescriptor = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromAuthoringConfig: fromAuthoringConfig
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "targetLocator",
                Selector$SmartcutsMacros.selector_encode(v.targetLocator)
              ],
              [
                "labeledValue",
                labeledRadioInputValue_encode(v.labeledValue)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
  if (targetLocator.TAG === /* Ok */0) {
    var labeledValue = labeledRadioInputValue_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledValue"), null));
    if (labeledValue.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                targetLocator: targetLocator._0,
                labeledValue: labeledValue._0
              }
            };
    }
    var e = labeledValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labeledValue" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = targetLocator._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".targetLocator" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$3(param) {
  return "{targetLocator: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.targetLocator) + ", labeledValue}");
}

function fromParamDescriptor(param) {
  var match = param.originalLabeledValue;
  var match$1 = match.value;
  var options = match$1.options;
  var selected = Caml_array.get(options, match$1.indexSelected);
  return {
          targetLocator: param.targetLocator,
          labeledValue: {
            label: match.label,
            value: {
              options: options,
              selected: selected
            }
          }
        };
}

function toCommandValueForPlayback(param) {
  return {
          selector: param.targetLocator,
          radioInputParam: param.labeledValue
        };
}

var PlaybackParamValue = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  stringify: stringify$3,
  fromParamDescriptor: fromParamDescriptor,
  toCommandValueForPlayback: toCommandValueForPlayback
};

exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* DOM-SmartcutsMacros Not a pure module */
